/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ContractPersonRole = {
    Owner: 'Owner',
    Insured: 'Insured',
    OwnerAndInsured: 'OwnerAndInsured'
} as const;
export type ContractPersonRole = typeof ContractPersonRole[keyof typeof ContractPersonRole];


export function instanceOfContractPersonRole(value: any): boolean {
    for (const key in ContractPersonRole) {
        if (Object.prototype.hasOwnProperty.call(ContractPersonRole, key)) {
            if (ContractPersonRole[key as keyof typeof ContractPersonRole] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ContractPersonRoleFromJSON(json: any): ContractPersonRole {
    return ContractPersonRoleFromJSONTyped(json, false);
}

export function ContractPersonRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractPersonRole {
    return json as ContractPersonRole;
}

export function ContractPersonRoleToJSON(value?: ContractPersonRole | null): any {
    return value as any;
}

export function ContractPersonRoleToJSONTyped(value: any, ignoreDiscriminator: boolean): ContractPersonRole {
    return value as ContractPersonRole;
}

